import {createContext}  from 'react'


export const UserContext = createContext(null)

export const ViewContext = createContext(null);

export const ToggleOverlay = createContext(null);